import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { Transaction } from '@kr/models';

import { TransactionDetailsComponent } from './transaction-details.component';

@Injectable()
export class TransactionDetailsDialog {
  readonly #dialog = inject(DialogService);

  open(transaction: Transaction): DialogRef {
    return this.#dialog.open(TransactionDetailsComponent, { transaction });
  }
}
